'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaGbp = function FaGbp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.3 25.4v8.2q0 0.3-0.2 0.5t-0.5 0.2h-21.4q-0.3 0-0.5-0.2t-0.2-0.5v-3.4q0-0.3 0.2-0.5t0.5-0.2h2.2v-8.5h-2.1q-0.4 0-0.6-0.2t-0.2-0.6v-2.9q0-0.3 0.2-0.5t0.6-0.2h2.1v-5q0-3.8 2.7-6.3t7.1-2.4q4.1 0 7.4 2.7 0.2 0.2 0.3 0.5t-0.2 0.5l-2.3 2.8q-0.2 0.3-0.5 0.3-0.3 0.1-0.5-0.1-0.1-0.2-0.6-0.5t-1.5-0.7-2.1-0.4q-1.9 0-3.1 1.1t-1.1 2.7v4.8h6.8q0.3 0 0.5 0.2t0.2 0.5v2.9q0 0.3-0.2 0.5t-0.5 0.3h-6.8v8.4h9.2v-4q0-0.3 0.2-0.5t0.5-0.2h3.7q0.3 0 0.5 0.2t0.2 0.5z' })
        )
    );
};

exports.default = FaGbp;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-icons/lib/fa/gbp.js
 ** module id = 1614
 ** module chunks = 0
 **/